import React from "react";
import styles from "./place-offer-skeleton.module.scss";
import SkeletonC from "../../../stories/common/skeleton";

const PlaceOfferSkeleton = () => {
  return (
    <div className={styles.placeOffer}>
      <SkeletonC width="100%" height="30px" className={styles.title}/>
      <div>
        <SkeletonC width="100%" height="50px" className={styles.sub_skeleton} />

        <SkeletonC width="100%" height="50px"className={styles.skeleton}/>
      </div>
      <div className={styles.btnWrap}>
        <SkeletonC width="100%" height="60px"className={styles.sub_skeleton} />
        <SkeletonC width="100%" height="30px" className={styles.linkBtn}/>
      </div>
    </div>
  );
};

export default PlaceOfferSkeleton;
